import './index.css'

const FilterGroup = props => {
  const employmentListContainer = () => {
    const {employmentTypesList, setEmploymentType, activeCheckboxList} = props

    return employmentTypesList.map(eachItem => {
      const onChangeEmploymentType = (isChecked, employmentTypeId) => {
        setEmploymentType(isChecked, employmentTypeId)
      }
      return (
        <li className="employment-item" key={eachItem.employmentTypeId}>
          <input
            type="checkbox"
            id={eachItem.employmentTypeId}
            onChange={e =>
              onChangeEmploymentType(
                e.target.checked,
                eachItem.employmentTypeId,
              )
            }
            checked={activeCheckboxList.includes(eachItem.employmentTypeId)}
          />
          <label className="label" htmlFor={eachItem.employmentTypeId}>
            {eachItem.label}
          </label>
        </li>
      )
    })
  }

  const salaryRangeContainer = () => {
    const {salaryRangesList, onChangeUpdateSalaryRange} = props

    return salaryRangesList.map(eachItem => {
      const handleSalaryRange = () => {
        onChangeUpdateSalaryRange(eachItem.salaryRangeId)
      }
      return (
        <li
          className="employment-item"
          key={eachItem.salaryRangeId}
          onChange={handleSalaryRange}
        >
          <input
            type="radio"
            className="radio"
            id={eachItem.salaryRangeId}
            name="option"
          />
          <label className="label" htmlFor={eachItem.salaryRangeId}>
            {eachItem.label}
          </label>
        </li>
      )
    })
  }

  return (
    <>
      <h1 className="filter-heading">Type of Employment</h1>
      <ul className="employment-container">{employmentListContainer()}</ul>
      <hr className="line" />
      <h1 className="salary-heading">Salary Range</h1>
      <ul className="employment-container">{salaryRangeContainer()}</ul>
      <ul />
    </>
  )
}

export default FilterGroup
